import axios from 'axios'

const DEFAULT_PARAMS = {
  'page_size': 10
}
export default {
  getMany (params = {}) {
    return axios.get('/api/data/officers', {
      params: {
        ...DEFAULT_PARAMS,
        ...params
      }
    })
  }
}
